import { ProductGallery } from './ProductGallery';

export type { TypeProductGalleryProps } from './types';
export default ProductGallery;
